import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Card, Button, Paragraph } from '../../../legacy/hui/src/styled';
import moderationAlertIcon from '../../images/moderation-alert-icon.svg';
import ShadowCard from '../ShadowCard';

export const TitleCard = Card.Section.extend`
  display: flex;
  align-items: center; 
  position: relative
`;

const ModerationAlertIcon = styled.img`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    display: inline-block;
    padding-right: 1.2rem;
    flex-shrink: 0;
  }
`;

export class ContactSupportCard extends React.Component {
  static propTypes = {
    messageLink: PropTypes.string,
    type: PropTypes.string
  };

  render() {
    const { messageLink, type, ...rest } = this.props;
    return (
      <ShadowCard snow p={0} mt={1} {...rest}>
        <TitleCard primary p={1} pr={2}>
          {type === 'moderation' && <ModerationAlertIcon src={moderationAlertIcon} />}
          {type === 'moderation' && `We need more info regarding your job`}
          {type === 'closed' && `Your job is now closed`}
        </TitleCard>
        <Card.Section
          p={0.5}
          pl={type === 'moderation' ? 4 : 1}
          pr={1.5}
          style={{ boxShadow: 'none' }}
        >
          <Paragraph m="0.5rem 0 1rem" style={{ lineHeight: 1 }}>
            {type === 'moderation' &&
              `Please provide more information about your job so we can ensure we connect you with relevant businesses.`}
            {type === 'closed' &&
              `If you have any questions or need assistance, you're welcome to chat with us at hipages support.`}
          </Paragraph>
          <a href={messageLink}>
            <Button style={{ float: 'right', margin: '0 20px 10px', padding: '7px 17px' }}>
              Contact Support
            </Button>
          </a>
        </Card.Section>
      </ShadowCard>
    );
  }
}
